import { css } from 'styled-components';

import { Typography } from 'src/app/components/Elements/Typography';
import { useDeliveryAddressById } from 'src/app/hooks/data/deliveryAddress';

import { ContrastedTitle } from '..';

import { CardItemContainer } from './styles';

interface AddressSectionProps {
  deliveryAddressId: string;
  address?: string;
  addressTwo?: string;
  city?: string;
  combinedAddress: string;
  isPickupStationOrder: boolean;
  name?: string;
  state?: string;
  zipCode?: string;
}

export const AddressSection = ({
  deliveryAddressId,
  address,
  addressTwo,
  city,
  combinedAddress,
  isPickupStationOrder,
  name,
  state,
  zipCode,
}: AddressSectionProps) => {
  const { isLoading: isLoadingDeliveryAddress } = useDeliveryAddressById(deliveryAddressId);

  return (
    <CardItemContainer>
      <ContrastedTitle title={isPickupStationOrder ? 'Location' : 'Address'} inOrderSummary={true} />
      {isLoadingDeliveryAddress && (
        <Typography
          variant="body"
          css={css`
            color: ${({ theme }) => theme.colors.capsuleBlue50};
          `}
          aria-hidden="true"
        >
          ...
        </Typography>
      )}

      {isPickupStationOrder && !isLoadingDeliveryAddress && (
        <>
          <Typography variant="bodyBold">{name}</Typography>
          <Typography variant="body">{address}</Typography>
          {addressTwo && <Typography variant="body">{addressTwo}</Typography>}
          <Typography variant="body">{`${city}, ${state} ${zipCode}`}</Typography>
        </>
      )}

      {!isPickupStationOrder && !isLoadingDeliveryAddress && (
        <>
          <Typography data-cy={`order-address`} variant="body">
            {combinedAddress}
          </Typography>
          {addressTwo && (
            <Typography data-cy={`order-address-two`} variant="body">
              {addressTwo}
            </Typography>
          )}
        </>
      )}
    </CardItemContainer>
  );
};
